/* eslint-disable jsx-a11y/alt-text */
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import {
  Avatar,
  Card,
  Col,
  Row,
  message,
  Typography,
  Badge,
  Button,
  Space,
  Image,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Layout from '../../../layouts/User';
import styles from '../index.module.scss';
import { useSelector } from 'react-redux';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import Step from '../step';
import { ORDER_SERVICE_CATEGORY } from '../../../reducers/actions/orderService';

interface Technician {
  name: string;
  phone: string;
  address: string;
  province: string;
  district: string;
  subDistrict: string;
  postCode: string;
}

interface ServiceJob {
  _id: string;
  user: string;
  serviceCategory: string;
  topic: string;
  description: string;
  technician: Technician;
  services: object;
  idCard: string;
  status: string;
  remark: string[];
}

interface Category {
  label: string;
  value: string;
}

export type Props = {};

const ServiceListings: React.FC<Props> = (props) => {
  const { Text } = Typography;
  const [loading, setLoading] = useState(false);
  // const [categoriesHeader, setCategoriesHeader] =
  //   useState<string>('');
  const [contextCategory, setContextCategory] = useState<string>('');
  const [serviceJobs, setServiceJobs] = useState<ServiceJob[]>([]);
  const [size, setSize] = useState<SizeType>('large');

  const user = useSelector((state: any) => state.user);

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query = useQuery();

  const category = useSelector(() => {
    return query.get('category') || '';
  });

  const getServices = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/applyJobs', {
        params: {
          status: 'approve',
          category,
          province: query.get('province'),
          district: query.get('district'),
          subDistrict: query.get('subDistrict'),
          postCode: query.get('postCode'),
        },
      });

      const { data } = res?.data?.data;
      setServiceJobs(data);
    } catch (error: any) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };

  const JobListings = () => {
    return (
      <>
        {serviceJobs.length ? (
          serviceJobs.map((job) => (
            <div style={{ padding: '5px 0px ' }}>
              <Card style={{ borderRadius: '5px' }}>
                <Row
                  justify="start"
                  gutter={[32, 48]}
                  style={{ paddingTop: '5px' }}
                >
                  <Col>
                    <Avatar
                      size={{
                        xs: 64,
                        sm: 64,
                        md: 64,
                        lg: 64,
                        xl: 80,
                        xxl: 100,
                      }}
                      src={job.idCard}
                    />
                  </Col>
                  <Col flex={10}>
                    <Text strong style={{ fontSize: '20px' }}>
                      {job.technician.name}
                    </Text>
                    <div>
                      <Text style={{ color: '#727A86' }}>
                        {job.technician.phone}
                      </Text>
                    </div>
                    <div>
                      <Text style={{ color: '#727A86' }}>
                        {job.description}
                      </Text>
                    </div>
                  </Col>
                  <Col flex={1} style={{ textAlign: 'center' }}>
                    <Link
                      to={`/services/contact/${
                        job._id
                      }?province=${query.get('province')}`}
                      state={{ category }}
                      key={job._id}
                    >
                      <Button
                        block
                        type="primary"
                        size={size}
                        style={{
                          background: '#0063F2',
                          borderRadius: '10px',
                        }}
                      >
                        ติดต่อช่าง
                      </Button>
                    </Link>
                    <br />
                    <br />
                    <Link
                      to={`/services/jobs/${
                        job._id
                      }?province=${query.get('province')}`}
                      state={{ category }}
                      key={job._id}
                    >
                      <span style={{ color: 'rgb(114, 122, 134)' }}>
                        ดูเพิ่ม &gt;
                      </span>
                    </Link>
                  </Col>
                </Row>
                <Col>
                  <div className={styles.jobImages}>
                  <Image.PreviewGroup>
                    {Object.values(job?.services)
                      .flat()
                      .map((imgUrl: any, i: number) => (
                        <Image
                          className={styles.jobInfoImage}
                          src={imgUrl}
                          key={`service-img-${i}`}
                        />
                      ))}
                    </Image.PreviewGroup>
                  </div>
                </Col>
              </Card>
            </div>
          ))
        ) : (
          <div className={styles.noService}>
            ไม่มีช่างในหมวดหมู่นี้
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    getServices();
    // getCategoriesHeader();
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <Layout>
        <div style={{ paddingTop: '16px' }}>
          <Button type="link" onClick={() => navigate(-1)}>
            <LeftOutlined /> ย้อนกลับ
          </Button>
          <h1>
            ช่าง "
            {ORDER_SERVICE_CATEGORY[query.get('category') || '']}"
          </h1>
        </div>

        <div style={{ marginTop: '16px' }}>
          <Step current={1} />
          <br />
          <div style={{ padding: '3px 0px ' }}>
            {loading ? (
              <div style={{ textAlign: 'center' }}>
                <LoadingOutlined className={styles.loadingIcon} />
              </div>
            ) : (
              <div>
                <JobListings />
              </div>
            )}
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ServiceListings;
